import React from "react";
import { Link } from "react-router-dom";
import NavbarHome from "../../../components/ui/NavbarHome";

export default function EmailVerified() {
  return (
    <div>
      <NavbarHome />
      <div className="min-h-full relative flex items-center justify-center sm:mt-24 mt-8 sm:px-6 lg:px-8">
        <div className="max-w-xl w-full bg-white p-4 shadow-lg rounded-xl border-2 space-y-8 sm:mx-0 mx-6">
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Email Verified successfully!
            </h2>
          </div>
          <div className="rounded-md space-y-4">
            <p>
              We have successfully verified your email please{" "}
              <Link to="/login" className="text-blue-600">
                Login here{" "}
              </Link>{" "}
              To continue
            </p>
          </div>
          <div className="mb-28"></div>
        </div>
      </div>
    </div>
  );
}
